import {useContext} from "react";
import {LessonNavigationContext} from "../context/LessonNavigationContext";

function useLessonNavigation() {
    const context = useContext(LessonNavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}

export { useLessonNavigation };